export type CustomerSupportActionsTypes =
  | 'maintenance_message_loaded'
  | 'maintenance_message_error';

export const MAINTENANCE_MESSAGE_LOADED: CustomerSupportActionsTypes = 'maintenance_message_loaded';
export const MAINTENANCE_MESSAGE_ERROR: CustomerSupportActionsTypes = 'maintenance_message_error';
